import React, { createContext, useContext, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getAssessmentResultsTrackingFetch, getLearningCenterBreakdownFetch } from 'store/middlewares/assessment.crud'
import { sumBy } from 'lodash'
import { testTakerRQ } from 'store/hooks'
import { ratingListLabel } from 'keys/rating'
import { genderLables } from 'keys/gender'
import { secretStorage } from 'config'
import { useSelector } from 'react-redux'
import { assessmentResultsTrackingHooks } from '.'
import { NotificationAlert } from 'components/Form'
import { getCurrentSemesterAndYear } from 'utils/general'
import { affiliationGroups } from 'keys'
import { affiliationGroupNames } from 'keys/affiliationGroups'
import { SystemReviewContext } from '../SystemReviewContext'
import AssessmentResultsTracking from './AssessmentResultsTracking'
import qc from 'keys/queryClient'

export const orderBtns = [{ label: "תוצאות", key: "results", }, { key: "name", label: 'א"ב' }]
export const profileBtns = [{ label: "תמונת מצב כללית", key: "BASIC", }, { key: "PROFILES", label: "חלוקה לדירוגים" }]

const AssessmentResultsTrackingPage = () => {
    const { draftAssessmentFilters, appliedAssessmentFilters, setDraftAssessmentFilters, setAppliedAssessmentFilters } = useContext(SystemReviewContext)

    const segmentTypeOptions = assessmentResultsTrackingHooks.useAllSegmentTypeOptions()

    const { roleIndex } = useSelector(state => state.user)
    const { grades } = useSelector(state => state.testTaker)

    const storage = secretStorage.getItem("user")
    const { user_data } = storage || {}
    const { affiliations, affiliation_groups } = user_data?.[roleIndex]?.user_data || {}
    const filterAffiliationGroups = affiliation_groups?.filter(group => affiliationGroupNames.includes(group.name))

    const allGrades = testTakerRQ.useGetAllGrades()

    const [selectedTab, setSelectedTab] = useState(0)
    const [learningCenter, setLearningCenter] = useState(null)
    const [date, setDate] = useState(null)
    const [order, setOrder] = useState(orderBtns[0].key)
    const [profileType, setProfileType] = useState(profileBtns[0].key)
    const [segmentation, setSegmentation] = useState(null)
    const [layout, setLayout] = useState(segmentTypeOptions[0])
    const [semesterAndYear, setSemesterAndYear] = useState({ ...getCurrentSemesterAndYear(), semester: null })
    const [totalTestTakers, setTotalTestTakers] = useState(0)

    const { data: cities = [] } = useQuery({
        queryKey: [qc.cities]
    })

    const data = useQuery({
        queryKey: [qc.assessmentResultsTrackingByAffiliations, date, selectedTab, order, appliedAssessmentFilters, layout, semesterAndYear],
        queryFn: async ({ signal }) => {
            const { data } = await getAssessmentResultsTrackingFetch({
                ...appliedAssessmentFilters,
                semester_and_year: semesterAndYear,
                layout,
                date,
            }, order, selectedTab, signal)

            let nData

            const test_taker_execution_count = sumBy(data, 'test_taker_execution_count')
            setTotalTestTakers(test_taker_execution_count)

            if (layout?.id == 'rating') {
                nData = data.map(item => ({
                    ...item,
                    name: ratingListLabel[item.id - 1],
                }))
            }
            else if (appliedAssessmentFilters.layout_type?.id == 'gender') {
                nData = data.map(item => ({
                    ...item,
                    name: genderLables[item.id]
                }))
            }

            return nData || data
        },
    })

    // פירוט מרכזי למידה לטולטיפ — רץ במקביל לקריאה הראשית ולא מעכב אותה
    const lcBreakdown = useQuery({
        queryKey: [qc.learningCenterBreakdown, date, appliedAssessmentFilters, layout, semesterAndYear],
        queryFn: async ({ signal }) => {
            const { data } = await getLearningCenterBreakdownFetch({
                ...appliedAssessmentFilters,
                semester_and_year: semesterAndYear,
                date,
            }, layout, null, signal)
            return data
        },
    })

    const commonValue = {
        selectedTab, setSelectedTab,
        date, setDate,
        segmentation, setSegmentation,
        order, setOrder,
        grades: allGrades,
        totalTestTakers, setTotalTestTakers,
        learningCenter, setLearningCenter,
        data,
        lcBreakdown,
        layout, setLayout,
        profileType, setProfileType,
        semesterAndYear, setSemesterAndYear,
        affiliations, affiliationGroups: filterAffiliationGroups, grades, cities,
        isSchoolGroup: draftAssessmentFilters.group?.name == affiliationGroups.schools
    }

    return (
        <AssessmentResultsTrackingContext.Provider value={commonValue}>
            <AssessmentResultsTracking />
            <NotificationAlert
                title={"חשוב לדעת!"}
                description={
                    <div>
                        {` דירוג ביצועי הילדים מבוסס על נתונים מצומצמים בלבד. הדירוגים עשויים להשתנות ככל שיצטברו נתוני ביצועים של ילדים בכיתות הטרוגניות מהחינוך הרגיל.    `}
                        <div>{" לנוחות הקריאה עיגלנו את האחוזים ולכן ייתכנו פערים קלים."}</div>
                    </div>
                }
                storageKey="assessments-review-message-approved"
                actionLabel={"הבנתי"}
            />
        </AssessmentResultsTrackingContext.Provider>
    )
}

export const AssessmentResultsTrackingContext = createContext()
export default AssessmentResultsTrackingPage